import { Controller } from "@hotwired/stimulus"

// Shows a clear (X) icon inside the search box only when there's a query (the
// submit button beside the field already carries the magnifier). The optional
// `search` target, if present, is shown only when the field is empty. Clicking
// the X empties the field and submits the form so results reset.
export default class extends Controller {
  static targets = ["input", "search", "clear"]

  connect() {
    // Whether a search is actually applied right now (the field loaded with a
    // value from the server). Used so clearing an unsubmitted query just empties
    // the field instead of firing a pointless empty search.
    this.searchApplied = this.inputTarget.value.trim().length > 0
    this.update()
  }

  update() {
    const hasValue = this.inputTarget.value.trim().length > 0
    if (this.hasSearchTarget) this.searchTarget.classList.toggle("hidden", hasValue)
    this.clearTarget.classList.toggle("hidden", !hasValue)
  }

  clear() {
    this.inputTarget.value = ""
    this.update()
    // Only reset results if a search was actually applied; otherwise just clear.
    if (this.searchApplied) {
      this.searchApplied = false
      const form = this.element.closest("form")
      if (form) {
        form.requestSubmit ? form.requestSubmit() : form.submit()
      }
    }
    this.inputTarget.focus()
  }
}
